/** @module primary-nav */

/**
 * Checks whether a component matching selector <code>[primary-nav]</code> exists and loads further resources and
 * initializes the component, if so.
 * @return {Promise<void>}
 */
export async function initPrimaryNav() {
    const primaryNav = document.querySelector('[data-primary-nav]');

    if (primaryNav) {
        const { PrimaryNav } = await import(/* webpackMode: "eager" */ './inc/primary-nav.async'),
            pn = new PrimaryNav({ primaryNav, breakpoint: 'desktop' });

        if (process.env.NODE_ENV !== 'production') {
            // debugging helper
            window.primaryNav = pn;
        }
    }
}
